<div fxFlexFill fxLayout="row" fxLayoutAlign="start stretch" class="wrapper">
  <div
    class="hidden md:flex-row md:basis-2/5 tips md:flex justify-center items-center flex-shrink-0 flex-grow-0"
  >
    <div class="flex flex-col justify-center items-center mx-6">
      <mat-icon [inline]="true">info</mat-icon>
      <p>{{ randomTip }}</p>
    </div>
  </div>
  <div fxFlex="0 1 100" fxLayout="column" fxLayoutAlign="start stretch">
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      fxFlex="0 0 auto"
      class="logo"
    >
      <div
        fxLayout="row"
        fxFlex="0 0 90"
        fxFlex.gt-sm="0 0 40"
        fxLayoutAlign="center center"
      >
        <img
          src="/assets/hirelogic.png"
          alt="HireLogic logo"
          class="basis-4/5 max-w-64"
        />
      </div>
    </div>
    <div class="flex flex-col justify-start items-stretch text-center">
      <div fxLayout="row" fxLayoutAlign="center start">
        <form
          fxLayout="column"
          [formGroup]="form"
          (submit)="login()"
          fxFlex="0 0 90"
          fxFlex.gt-sm="0 0 40"
        >
          <p *ngIf="reason">{{ reason }}</p>
          <mat-form-field fxFlex="100">
            <mat-label>Email or username</mat-label>
            <input
              matInput
              placeholder="Email or Username"
              id="username"
              name="Username"
              autocomplete="username"
              formControlName="email"
              type="email"
              autofocus
              required
              [disabled]="isLoading"
            />
          </mat-form-field>
          <mat-form-field fxFlex="100">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              placeholder="Password"
              name="Password"
              formControlName="password"
              id="password"
              required
            />
          </mat-form-field>
          <button
            type="submit"
            [disabled]="isLoading || !form.valid"
            mat-flat-button
            color="primary"
          >
            Login
          </button>
        </form>
      </div>
      <a [routerLink]="['/forgot-password']" class="my-12">Forgot Password?</a>
      <div class="error" fxLayout="row" fxLayoutAlign="center center">
        <p>
          &nbsp;<span [class.hidden]="!error">{{ error }}</span>
        </p>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <p>
          Don't have an account yet? <a [routerLink]="['/sign-up']">Sign Up</a>
        </p>
      </div>
    </div>
  </div>
</div>
